import axios from 'axios';
import { urlUploadDB } from '../utils';

export const apiUploadDB = axios.create({
    baseURL: `${urlUploadDB}`
});